<script>
import Cookies from "js-cookie";
import {notificationMethods, bankPaymentMethods, customerMethods} from "@/state/helpers";
import {required} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Banka Ödemeleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      file: null,
      customerFilter:'',
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      selectedCustomer:{},
      selectedEditCustomer:{},
      formSelectCustomers:[],
      items: [],
      currentUser: JSON.parse(Cookies.get('user')),
      bankPayments: [],
      selectAll: false,
      title: "Banka Ödemeleri Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Banka Ödemeleri",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      deletesModal: false,
      noDeleteModal: false,
      formError: '',
      editFormError: '',
      addForm: {
        upload: null
      },
      editForm: {
        customerId: null,
        contractNumber: null,
        amount: null
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 50,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      selectedIds: [],
      fields: [
        { key: 'select', label: '', sortable: false },
        {
          key: "paymentDate",
          label: 'Ödeme Tarihi',
          sortable: false,
        },
        {
          key: "description",
          label: 'Açıklama',
          sortable: false,
        },
        {
          key: "paymentAmount",
          label: 'Tutar',
          sortable: false,
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput: 1
    };
  },
  validations: {
    addForm: {
      upload: {required},
    },
    editForm: {
      customerId: {required},
      amount: {required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch: {
    selectAll(newVal) {
      this.toggleSelectAll(newVal);
    },
    page(newPage) {
      this.pageInput = newPage;
      this.getBankPayments(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getBankPayments();
        } else {
          this.page = 1;
        }
      }
    },
    customerFilter(newFilter) {
      if (newFilter.length > 2) {
        this.getCustomersForFormSelect(newFilter)
      } else {
        this.formSelectCustomers = [];
      }
    },
  },
  mounted() {
    this.getBankPayments();
  },
  methods: {
    ...bankPaymentMethods,
    ...notificationMethods,
    ...customerMethods,
    toggleSelectAll(selectAll) {
      this.selectedIds = selectAll ? this.items.map(item => item.id) : [];
    },
    getSelectedItems() {
      /* eslint-disable */
      this.customerFilter=''
      this.editForm.customerId=''
      this.editForm.contractNumber=''
      this.editId = 'asdasd'
      this.editModal = true;
    },
    onFileChange(e) {
      this.file = e.target.files[0];
    },

    handleBankPayment(){
      if (!this.file)
        return;
      let data = new FormData()
      data.append('upload',this.file)

      this.imgLoading=true;
      this.createBankPayment(data).then(()=>{
        this.getBankPayments()
        this.imgLoading=false;
        this.showModal =false
        this.resetForm()
      })
    },
    resetForm() {
      this.addForm = {
        upload: null,
      };
      this.file = null
      this.editForm = {
        paymentDate: null,
        description: null,
        paymentAmount: null,
      };
      this.addSubmitted=false,
          this.editSubmitted=false
    },
    doSearch() {
      if (this.page === 1) {
        this.getBankPayments();
      } else {
        this.page = 1;
      }
    },
    getBankPayments(page = this.page) {
      this.itemsLoaded = false;
      let filter = {}
      if (this.filter) {
        filter.name = this.filter;
      }
      this.fetchBankPayments({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;
        // getting category ready for fields
        this.items = res.docs.map(elem => {
          return elem;
        })
        this.itemsLoaded = true;
      })
    },

    handleEditSubmit() {
      if(this.selectedIds.length===0){
        this.updateBankPayment({
          id: this.editId,
          data: {
            ...this.editForm
          },
        }).then(() => {
          this.toastMessage = "Banka Ödemesi başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.editModal = false;
          this.getBankPayments();
          this.addForm.name = "";
          this.addForm.domain = "";
        }).catch((err) => {
          this.toastMessage = "Sistemde bir hata oluştu!";
          this.toastAction = "error";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
        })
      }
      else {
        this.updateBankPaymentMulti({
          data: {
            ...this.editForm,
            bankPaymentIds: this.selectedIds
          },
        }).then(() => {
          this.toastMessage = "Banka Ödemesi başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.editModal = false;
          this.getBankPayments();
          this.selectedIds = []
        }).catch((err) => {
          this.toastMessage = "Sistemde bir hata oluştu!";
          this.toastAction = "error";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
        })
      }
    },
    handleDeleteSubmit() {
      this.deleteBankPayment(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Kayıt başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getBankPayments();
      })
    },
    handleDeletesSubmit() {
      this.deletesBankPayment().then(() => {
        this.deletesModal = false;
        this.toastMessage = "Kayıtlar başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getBankPayments();
      })
    },
    handleLaterBankPaymentSubmit() {
      this.laterBankPayment({
        id: this.editId,
        data: {}
      }).then(() => {
        this.editModal = false;
        this.toastMessage = "Kayıt başarıyla sonraya alındı!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getBankPayments();
      })
    },
    openEdit(bankPayment) {
      this.customerFilter=''
      this.editForm.customerId=''
      this.editForm.contractNumber=''
      this.editForm.amount = bankPayment.paymentAmount-bankPayment.payAmount;
      this.editId = bankPayment._id;
      this.editModal = true;
    },
    openDelete(bankPayment) {
      this.deleteId = bankPayment._id;
      this.deleteModal = true;
    },
    openDeletes() {
      this.deletesModal = true;
    },
    turkishToLower(str) {
      let letters = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
      str = str.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) {
        return letters[letter];
      })
      return str.toLowerCase();
    },
    moneyFormat(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
      }).format(value);
    },
    getCustomersForFormSelect(){
      this.customersLoaded=false;
      let filter = {q:this.customerFilter}
      this.fetchCustomers({listType:'select',...filter}).then(res=>{
        if(res.docs.length>0){
          this.formSelectCustomers = res.docs;
        }
        this.customersLoaded=true;
      })
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <button class="btn btn-success ms-auto mb-2 right" @click="getSelectedItems">Toplu Ödeme Ekle</button>
            <button
                class="btn btn-danger ms-2 mb-2" style="margin-left:40px"
                @click="openDeletes();"
            >
              Banka Ödeme Listesini Temizle
            </button>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="resetForm(); showModal = true"
                >
                  Banka Ödeme Listesi Ekle
                </button>
              </div>
            </div>
            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:head(select)="data">
                    <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"></b-form-checkbox>
                  </template>
                  <template v-slot:cell(select)="data">
                    <b-form-checkbox :value="data.item.id"
                                     v-model="selectedIds" />
                  </template>
                  <template v-slot:cell(paymentDate)="data">
                    {{ new Date(data.item.paymentDate).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }) }}
                  </template>
                  <template v-slot:cell(paymentAmount)="data">
                    {{(data.item.payAmount) ? moneyFormat(data.item.paymentAmount-data.item.payAmount) : moneyFormat(data.item.paymentAmount) }}
                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input
                        :style="{width:'30px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}"
                        @keyup.enter="page=pageInput" v-model="pageInput" type="text" class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="md" v-model="showModal" title="Ödeme Listesi Ekle" hide-footer @hide="resetForm">
        <form @submit.prevent="handleBankPayment">
          <div class="row">

            <div class="col-12">
              <div class="mb-3">
                <label for="bankPaymentForm" class="form-label">Banka Ödeme Listesi</label>
                <input
                    type="file"
                    id="bankPaymentForm"
                    @change="onFileChange"
                    accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    class="form-control"
                    :class="{
                      'is-invalid': addSubmitted && !addForm.upload,
                }"
                />
              </div>
              <div
                  v-if="addSubmitted && !addForm.contractForm"
                  class="invalid-feedback"
              >
                Döküman girilmesi gerekli bir alandır.
              </div>
            </div>
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();">Vazgeç</b-button>
            <b-button type="submit" variant="success" class="ms-1">Ödeme Listesi Ekle</b-button>
          </div>
        </form>
      </b-modal>
      <b-modal size="md" v-model="editModal" title="Ödeme Ekle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="customerId">Müşteri</label>
                <b-dropdown :style="{border:'1px solid #ced4da',textAlign:'left'}" class=" d-flex customSelect" :text="editForm.customerId ? selectedEditCustomer.name : 'Müşteri Yok'"  variant="text-dark">
                  <form>
                    <input v-model="customerFilter" type="text" :style="{borderTop:'none'}"  class="dropdown-item" placeholder="ara...">
                  </form>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item class="w-100 " @click="()=>{
                    selectedCustomer={}
                    editForm.customerId=''
                  }">
                    Müşteri seç
                  </b-dropdown-item>
                  <b-dropdown-item class="w-100 "
                                   @click="()=>{
                    editForm.customerId=customer.id
                    selectedEditCustomer = customer
                  }" :key="customer.id" v-for="customer in formSelectCustomers">
                    {{customer.name}}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="col-12" >
              <div class="mb-3">
                <label for="amount">Evrak Numarası</label>
                <input
                    id="amount"
                    type="text"
                    v-model="editForm.contractNumber"
                    class="form-control"
                    placeholder="Evrak numarası"
                />
              </div>
            </div>
            <div class="col-12" v-if="selectedIds.length===0">
              <div class="mb-3">
                <label for="amount">Tutar</label>
                <input
                    id="amount"
                    type="text"
                    v-model="editForm.amount"
                    class="form-control"
                    placeholder="Tutar giriniz"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç
            </b-button
            >
            <b-button variant="info" v-if="selectedIds.length===0" @click="handleLaterBankPaymentSubmit()"
            >Sonra Kontrol Et
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Ödeme Ekle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu Siteyi silmek istediğinize emin misiniz? Silinmiş Siteyi geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="deletesModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Listeyi silmek istediğinize emin misiniz? Silinmiş listeyi geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeletesSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız Siteyi silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.pill span {
  padding: 6px 12px 4px 12px;
}

</style>
